<template>
	<v-dialog :value="value" max-width="420" @input="$emit('input', $event)">
		<v-card class="vd-card">
			<div class="vd-head">
				<v-icon color="primary" class="mr-2">mdi-percent-outline</v-icon>
				<div>
					<div class="vd-title">Nuova aliquota IVA</div>
					<div class="vd-sub">Sarà proponibile nella scheda dei prodotti</div>
				</div>
				<v-spacer></v-spacer>
				<v-btn icon small title="Chiudi" @click="chiudi"><v-icon>mdi-close</v-icon></v-btn>
			</div>

			<v-form class="vd-body" @submit.prevent="aggiungi">
				<v-text-field
					ref="campo"
					v-model="aliquota"
					type="number"
					min="0"
					max="100"
					step="0.01"
					label="Aliquota"
					suffix="%"
					outlined
					class="vd-input"
					:error-messages="errore"
					@input="errore = ''"
				></v-text-field>

				<div class="vd-section">Aliquote comuni</div>
				<div class="vd-chips">
					<v-chip
						v-for="c in comuni"
						:key="c"
						small
						:outlined="+aliquota !== c || aliquota === ''"
						:color="esiste(c) ? 'grey' : 'primary'"
						:disabled="esiste(c)"
						:title="esiste(c) ? 'Già presente' : ''"
						@click="scegli(c)"
					>
						{{ c }}%
					</v-chip>
				</div>

				<div class="vd-switch">
					<div>
						<div class="font-weight-medium">Attiva subito</div>
						<div class="vd-sub">Spenta, resta in elenco ma non si può scegliere sui prodotti</div>
					</div>
					<v-switch v-model="attiva" color="primary" class="mt-0 pt-0" hide-details></v-switch>
				</div>
			</v-form>

			<div class="vd-foot">
				<v-btn text color="primary" @click="chiudi">Annulla</v-btn>
				<v-btn depressed color="primary" data-tour="add-confirm" @click="aggiungi">Aggiungi</v-btn>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
// dialog di aggiunta di un'aliquota IVA: valida e restituisce { vat, is_active }, il salvataggio lo fa la pagina
export default {
	name: 'VatDialog',
	props: {
		value: { type: Boolean, default: false },
		// valori gia' presenti, per bloccare i doppioni
		esistenti: { type: Array, default: () => [] },
	},
	data() {
		return {
			aliquota: '',
			attiva: true,
			errore: '',
			comuni: [22, 10, 5, 4, 0],
		};
	},
	watch: {
		value(aperto) {
			if (!aperto) return;
			this.aliquota = '';
			this.attiva = true;
			this.errore = '';
			this.$nextTick(() => setTimeout(() => this.$refs.campo && this.$refs.campo.focus(), 150));
		},
	},
	methods: {
		esiste(n) {
			return this.esistenti.some(v => +v === +n);
		},
		scegli(n) {
			this.aliquota = String(n);
			this.errore = '';
		},
		aggiungi() {
			const testo = String(this.aliquota).trim().replace(',', '.');
			const numero = Number(testo);

			if (testo === '' || isNaN(numero)) {
				this.errore = "Scrivi il valore dell'aliquota";
				return;
			}
			if (numero < 0 || numero > 100) {
				this.errore = "L'aliquota deve essere tra 0 e 100";
				return;
			}
			if (this.esiste(numero)) {
				this.errore = `L'aliquota ${numero}% esiste già`;
				return;
			}

			this.$emit('add', { vat: numero, is_active: this.attiva });
		},
		chiudi() {
			this.$emit('input', false);
		},
	},
};
</script>

<style scoped>
.vd-card {
	border-radius: 10px !important;
	overflow: hidden;
}
.vd-head {
	display: flex;
	align-items: center;
	padding: 14px 16px;
	border-bottom: 1px solid #e1e7ef;
}
.vd-title {
	font-weight: 600;
	font-size: 16px;
	color: #1f2d3d;
}
.vd-sub {
	font-size: 12px;
	color: #5f6b7a;
}
.vd-body {
	padding: 16px 16px 8px;
	background: #f3f6fa;
}
.vd-input ::v-deep input {
	font-size: 22px;
	font-weight: 600;
}
.vd-input ::v-deep input::-webkit-outer-spin-button,
.vd-input ::v-deep input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
.vd-input ::v-deep input[type='number'] {
	-moz-appearance: textfield;
}
.vd-input ::v-deep .v-input__slot {
	background: #fff !important;
}
.vd-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.vd-chips {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	margin-bottom: 16px;
}
.vd-switch {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	padding: 10px 12px;
	margin-bottom: 8px;
	font-size: 14px;
}
.vd-foot {
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	padding: 10px 16px;
	border-top: 1px solid #e1e7ef;
}
</style>
